import { render, staticRenderFns } from "./ContestNotification.vue?vue&type=template&id=4f574e7c&scoped=true"
import script from "./ContestNotification.vue?vue&type=script&lang=ts"
export * from "./ContestNotification.vue?vue&type=script&lang=ts"
import style0 from "./ContestNotification.vue?vue&type=style&index=0&id=4f574e7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f574e7c",
  null
  
)

export default component.exports